module.exports = __webpack_public_path__ + "img/votes-transparent.488b9b78.svg";